import React, { Component } from "react";
import { connect } from "react-redux";
import { getMarketAnalysis } from "./../../shared/requests-api";
import MarketAnalysisContent from "./MarketAnalysisContent";
import Loading from "../../../shared/Loading/Loading";
import R from "ramda";
import { receiveMarketAnalysis } from "../../actions";
import { getUserToken } from "../../shared/utils";
import {
	formatDateToPortugueseFormatReducedYearSpaced,
	decDaysToDate,
	formatDateToComputerDate
} from "./../../shared/utils";
import { NavLink } from "react-router-dom";
import { ROUTE_RANKING } from "./../../shared/constants";

const periods = [
	{
		title: "Últimas 24h",
		suffix: "24HoursAgo",
		description: (
			<p>
				Nesta cotação, você confere a <strong>média</strong> de preço de cada 1.000 milhas vendidas
				na MaxMilhas nas últimas 24 horas.
			</p>
		)
	},
	{
		title: formatDateToPortugueseFormatReducedYearSpaced(
			decDaysToDate(formatDateToComputerDate(new Date()), 3)
		),
		complement: "-3 Dias",
		suffix: "3DaysAgo",
		description: (
			<p>
				Nesta cotação, você confere a <strong>média</strong> de preço de cada 1.000 milhas vendidas
				na MaxMilhas, calculada entre 0h e 23h59 do terceiro dia anterior à data de hoje. <br />Já a{" "}
				<strong>variação</strong> compara o valor médio das últimas 24 horas com a data citada.
			</p>
		)
	},
	{
		title: formatDateToPortugueseFormatReducedYearSpaced(
			decDaysToDate(formatDateToComputerDate(new Date()), 7)
		),
		complement: "-7 Dias",
		suffix: "7DaysAgo",
		description: (
			<p>
				Nesta cotação, você confere a <strong>média</strong> de preço de cada 1.000 milhas vendidas
				na MaxMilhas, calculada entre 0h e 23h59 do sétimo dia anterior à data de hoje. <br />Já a{" "}
				<strong>variação</strong> compara o valor médio das últimas 24 horas com a data citada.
			</p>
		)
	},
	{
		title: formatDateToPortugueseFormatReducedYearSpaced(
			decDaysToDate(formatDateToComputerDate(new Date()), 30)
		),
		complement: "-30 Dias",
		suffix: "30DaysAgo",
		description: (
			<p>
				Nesta cotação, você confere a <strong>média</strong> de preço de cada 1.000 milhas vendidas
				na MaxMilhas, calculada entre 0h e 23h59 do trigésimo dia anterior à data de hoje. <br />Já
				a <strong>variação</strong> compara o valor médio das últimas 24 horas com a data citada.
			</p>
		)
	}
];

let idInterval;

class MarketAnalysis extends Component {
	constructor() {
		super();
		this.state = {
			position: 0,
			suffix: periods[0].suffix,
			period: periods[0].title,
			complement: periods[0].complement,
			description: periods[0].description
		};
	}

	componentDidMount() {
		const self = this;
		const { marketAnalysis, receiveMarketAnalysis } = this.props;

		if (!marketAnalysis && receiveMarketAnalysis) {
			self.setState({ loading: true });
			getMarketAnalysis(getUserToken())
				.then(response => {
					if (self._unmounted) return;
					self.setState({
						loading: false,
						error: false,
						position: 0
					});

					if (response.data && response.data.length) {
						response.data = response.data.map(analyze => {
							return analyze;
						});
					}

					let sorted = R.sortWith([R.ascend(R.path(["name"]))]);
					receiveMarketAnalysis(sorted(response.data));
				})
				.catch(res => {
					if (self._unmounted) return;
					self.setState({
						loading: false,
						error: true
					});
				});
		}
		idInterval = setInterval(
			function () {
				self.changeTab("right");
			}.bind(self),
			30 * 1000
		);
	}

	componentWillUnmount() {
		this._unmounted = true;
		clearInterval(idInterval);
	}

	changeTab(direction) {
		const self = this;
		let position = self.state.position;

		if (direction == "left") position--;
		if (direction == "right") position++;

		if (position < 0) position = 3;

		position %= 4;

		this.setState({
			position: position,
			suffix: periods[position].suffix,
			period: periods[position].title,
			complement: periods[position].complement,
			description: periods[position].description
		});
	}

	render() {
		const { suffix, period, position, description, loading, complement, error } = this.state;

		return (
			<div className="market-analysis">
				<div className="row no-margin">
					<div className="col-xs-16 menu-market-analysis">
						<div className="col-xs-16 v-center-columns text-center title">
							<NavLink to={`${ROUTE_RANKING}`} data-action="market-analysis-ranking">
								<p>
									<strong>Cotação de milhas</strong>
								</p>
							</NavLink>
						</div>
						<div className="col-xs-2 v-center-columns text-left arrows">
							<a
								className={"btn " + suffix}
								onClick={() => this.changeTab("left")}
								data-action="market-analysis-left"
							>
								<i className="icon-arrow-down left-arrow" />
							</a>
						</div>
						<div className="col-xs-8 v-center-columns text-center div-menu">
							<p className="menu-selected">
								<strong>{period}</strong>
								<br />
								{complement}
							</p>
						</div>
						<div className="col-xs-2 v-center-columns text-right arrows">
							<a
								className={"btn " + suffix}
								onClick={() => this.changeTab("right")}
								data-action="market-analysis-right"
							>
								<i className="icon-arrow-down right-arrow" />
							</a>
						</div>
					</div>

					{loading ? (
						<div className="col-xs-16 market-analysis-details">
							<div className="row">
								<Loading />
							</div>
						</div>
					) : (
						<MarketAnalysisContent
							suffix={suffix}
							marketAnalysis={this.props.marketAnalysis}
							position={position}
							description={description}
							error={error}
							period={period}
						/>
					)}
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	marketAnalysis: state.marketAnalysis.data
});

const mapDispatchToProps = dispatch => {
	return {
		receiveMarketAnalysis: data => dispatch(receiveMarketAnalysis(data))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(MarketAnalysis);
